
    // IMPORTS
    import { defineComponent, PropType } from 'vue'
    import { buildLocalization } from '@/util'

    import MyIcon from '@/components/common/my-icon.vue'

    export default defineComponent({
        name: 'equipmentSerialNumberCell',

        components: {
            MyIcon
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            click: (id: string) => true
        },

        props: {
            id: { type: String as PropType<string>, required: true },
            dataItem: { type: Object as PropType<any>, required: true }
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const computedData = { }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function onClick() {
                emit('click', props.id)
            }

            const publicMethods = { localize, onClick }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
